(function () {
  'use strict';

  var util = {
    parseJwt : function (jwt) {
      var parts = jwt.split('.');
      return {
        header : base64Json(parts[0]),
        payload : base64Json(parts[1])
      };
    },
    parseMultipartHeader : function (header) {
      var parts = header.split(/; */); // the space is technically optional
      return _.reduce(parts, function (map, part) {
        var pair = part.split('=');
        if (pair.length === 1) {
          pair.push(true); // e.g content-disposition: inline; ...
        } else if (_.startsWith(pair[1], '"') && _.endsWith(pair[1], '"')) {
          pair[1] = JSON.parse(pair[1]); // parse value as a string
        }
        map[pair[0]] = pair[1];
        return map;
      }, {});
    }
  };

  function base64Json(encoded) {
    return JSON.parse(atob(encoded));
  }

  angular
      .module('tf.retailer.Util', [])
      .constant('util', util)
      .service('dateUtil', DateUtil);

  function DateUtil($filter) {
    return {
      formatJsonDate : formatJsonDate
    };

    function formatJsonDate(json, format) {
      if (!json) return "";
      var date = $filter('date')(json, format);
      return date;
    };
  }

})();
